
export type UpdateUserProfile403 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
